import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { authGuard, linkValidGuard } from '@app/core/guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@module/link-validation/link-validation.component').then(
        (m) => m.LinkValidationComponent
      ),
  },
  {
    path: 'login',
    component: AuthLayoutComponent,
    canActivate: [linkValidGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('@module/auth/auth.component').then((m) => m.AuthComponent),
      },
    ],
  },
  {
    path: 'repair-journey',
    canActivate: [linkValidGuard, authGuard],
    loadComponent: () =>
      import('@module/repair-journey/repair-journey').then((m) => m.RepairJourney),
  },
];
